import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import { deleteGeographicZone } from '../../../../actions';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';

class DeleteGeographicZoneButton extends Component {
  state = {
    showWarningModal: false,
  };

  showDeleteModal = () => this.setState({ showWarningModal: true });

  closeDeleteModal = () => this.setState({ showWarningModal: false });

  handleDelete = () => {
    const { geographicZoneId, dispatchDeleteGeographicZone } = this.props;
    dispatchDeleteGeographicZone({ geographicZoneId });
  };

  render() {
    const { showWarningModal } = this.state;

    const warningModal = (
      <ConfirmationModal
        show={showWarningModal}
        onClickConfirm={this.handleDelete}
        onClickCancel={this.closeDeleteModal}
      />
    );

    const deleteButton = (
      <Button color="danger" onClick={this.showDeleteModal}>
        Eliminar
      </Button>
    );

    return (
      <Fragment>
        {deleteButton}
        {warningModal}
      </Fragment>
    );
  }
}

DeleteGeographicZoneButton.propTypes = {
  geographicZoneId: PropTypes.number.isRequired,
  dispatchDeleteGeographicZone: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchDeleteGeographicZone: deleteGeographicZone,
};

export default connect(null, mapDispatchToProps)(DeleteGeographicZoneButton);
